import Cookies from 'js-cookie'

const ls = window.localStorage;
const ss = window.sessionStorage;

export const Cookie = {
  set(name, value, config = {}) {
    // Cookies.set(name, value, { ...expires && { expires }, path: '/', domain })
    Cookies.set(name, value, { path: '/', ...config })
  },
  get(name) {
    return Cookies.get(name)
  },
  remove(name) {
    Cookies.remove(name, { path: '/' })
  },
  removeAll(curDomain) {
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
      for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=' + curDomain + ';expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
      }
    }
  }
}

export const Local = {
  // 判断浏览器是否支持LocalStorage
  hasLocalStorage: function() {
    return window.Storage && window.localStorage && window.localStorage instanceof Storage
  },
  get(key) {
    if (this.hasLocalStorage()) {
      if (key) return JSON.parse(ls.getItem(key))
      return null
    } else {
      return Cookie.get(key)
    }
  },
  set(key, val, day) {
    if (this.hasLocalStorage()) {
      const setting = arguments[0]
      if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object') {
        for (const i in setting) {
          ls.setItem(i, JSON.stringify(setting[i]))
        }
      } else {
        ls.setItem(key, JSON.stringify(val))
      }
    } else {
      Cookie.set(key, val, day)
    }
  },
  remove(key) {
    if (this.hasLocalStorage()) {
      ls.removeItem(key)
    } else {
      Cookie.remove(key)
    }
  },
  clear() {
    ls.clear()
  }
};


export const Session = {
  get(key) {
    if (key) return JSON.parse(ss.getItem(key))
    return null
  },
  set(key, val) {
    const setting = arguments[0]
    if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object') {
      for (const i in setting) {
        ss.setItem(i, JSON.stringify(setting[i]))
      }
    } else {
      ss.setItem(key, JSON.stringify(val))
    }
  },
  remove(key) {
    ss.removeItem(key)
  },
  clear() {
    ss.clear()
  }
}

export const getRouteTitleHandled = (route) => {
  let router = { ...route }
  let meta = { ...route.meta }
  let title = ''
  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      title = meta.title(router)
    } else {
      title = meta.title
    }
  }
  meta.title = title
  router.meta = meta
  return router
}

export const showTitle = (item) => {
  let { title } = item.meta
  if (!title) return
  title = (item.meta && item.meta.title) || item.name
  return title
}

/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {String} title     APP title
 * @param {Object} vm Vue实例
 */
export const setTitle = (routeItem, title) => {
  const handledRoute = getRouteTitleHandled(routeItem)
  const pageTitle = showTitle(handledRoute)
  const resTitle = pageTitle ? `${title} - ${pageTitle}` : title
  return resTitle
}

export const Dom = {
  hasClass(obj, cls) {
    return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
  },
  addClass(obj, cls) {
    if (!this.hasClass(obj, cls)) obj.className += " " + cls;
  },
  toggleClass(obj, cls) {
    if (this.hasClass(obj, cls)) {
      this.removeClass(obj, cls);
    } else {
      this.addClass(obj, cls);
    }
  },
  removeClass(obj, cls) {
    if (this.hasClass(obj, cls)) {
      var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
      obj.className = obj.className.replace(reg, ' ');
    }
  },
}

/**
 * @日期格式化，24小时制
 */
export const datefmt = (time = new Date(), fmt = 'YYYY-MM-DD hh:mm:ss') => {
  let date = typeof time === 'string' ? new Date(time) : time;
  // unicode字符
  let weekdays = ['\u65e5', '\u4e00', '\u4e8c', '\u4e09', '\u56db', '\u4e94', '\u516d'];
  let o = {
    "M+": date.getMonth() + 1,
    "D+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    "S+": date.getMilliseconds(),
    "w+": date.getDay()
  }
  if (/(Y+)/i.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (o.hasOwnProperty(k)) {
      if (k === "w+") {
        // fmt = fmt.replace("w", '\u661f\u671f' + weekdays[o[k]]) //星期
        fmt = fmt.replace("w", '\u5468' + weekdays[o[k]]) //周
      } else if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ?
          o[k] : ("00" + o[k]).substr(("" + o[k]).length))
      }
    }
  }
  return fmt
}

/**
 * 身份证校验
 */
export const checkIdcard = idCard => {
  if (idCard.slice(17, 18) == "x") {
    idCard = idCard.replace("x", "X");
  }
  idCard = idCard.toString();
  var city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  var tip = "";
  var pass = true;

  if (!idCard ||
    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
      idCard
    )
  ) {
    tip = "身份证号格式错误";
    pass = false;
  } else if (!city[idCard.substr(0, 2)]) {
    tip = "地址编码错误";
    pass = false;
  } else {
    //18位身份证需要验证最后一位校验位
    if (idCard.length == 18) {
      idCard = idCard.split("");
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = idCard[i];
        wi = factor[i];
        sum += ai * wi;
      }
      var last = parity[sum % 11];
      if (parity[sum % 11] != idCard[17]) {
        tip = "校验位错误";
        pass = false;
      }
    }
  }
  var obj = {
    status: pass,
    msg: tip
  };
  if (!pass) {
    return obj;
  }
  return obj;
};

/**
 * @检查证件合法性
 */
export const checkIdcardValid = (cardtype_id, cardnum) => {
  let result = {};
  result.status = true
  result.errtips = ''
  //2护照 '/^[a-z0-9]{5,17}$/i'
  //3港澳通行证、4台湾通行证、5军官证、6士兵证 '/^[a-z0-9]{5,12}$/i'
  switch (cardtype_id) {
    case 1:
      if (!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(cardnum)) {
        result.status = false
        result.errtips = '身份证格式错误'
      }
      break;
    case 2:
      if (!/^[a-z0-9]{5,17}$/i.test(cardnum)) {
        result.status = false
        result.errtips = '护照格式错误'
      }
      break;
    case 3:
    case 4:
    case 5:
    case 6:
      if (!/^[a-z0-9]{5,12}$/i.test(cardnum)) {
        result.status = false
        result.errtips = '证件格式错误'
      }
      break;
  }
  return result;
}

/**
 * 根据身份证号计算年龄
 */
export const calcIDCard = (IDCard) => {
  //获取用户身份证号码
  var userCard = IDCard.toString();
  //获取出生年月日
  var yearBirth = parseInt(userCard.substring(6, 10)); //出生年份
  var monthBirth = parseInt(userCard.substring(10, 12)); //出生月份
  var dayBirth = parseInt(userCard.substring(12, 14)); //出生日
  //获取当前年月日并计算年龄
  var myDate = new Date();
  var yearNow = parseInt(myDate.getFullYear()); //当前年份
  var monthNow = parseInt(myDate.getMonth() + 1); //当前月份
  var dayNow = parseInt(myDate.getDate()); //当前日
  var age = yearNow - yearBirth; //
  //
  // 6岁
  if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
    age--;
  }

  // 6岁半算作7岁
  // if (monthNow > monthBirth || (monthNow == monthBirth && dayNow > dayBirth)) {
  //   age++;
  // }

  return age;
}

/**
 * 防止重复点击
 */
let oldtime = '';

export const preventClick = (msc) => {
  if (oldtime == '') {
    oldtime = new Date().getTime();
    return true;
  } else {
    let newtime = new Date().getTime();
    if (newtime - oldtime > msc) {
      oldtime = new Date().getTime();
      return true;
    } else {
      return false;
    }
  }
}
/**
 * 初始化类型判断方法
 * 在exp对象上新增isNull, isUndefined, isObject, isArray, isString, isNumber, isBoolean, isFunction, isRegExp
 * 可以通过Exp.isUndefined ...这些进行数据格式判断
 */
let exp = {};
let type = (o) => {
  let s = Object.prototype.toString.call(o)
  return s.match(/\[object (.*?)\]/)[1].toLowerCase()
};

['Null',
  'Undefined',
  'Object',
  'Array',
  'String',
  'Number',
  'Boolean',
  'Function',
  'RegExp'
].forEach(function(t) {
  exp['is' + t] = function(o) {
    return type(o) === t.toLowerCase()
  }
});

export const Exp = exp;


/**
 * 解决遮罩层滚动穿透问题，分别在遮罩层弹出后和关闭前调用
 */
export const ModalHelper = (() => {
  var scrollTop;
  return {
    afterOpen: function() {
      scrollTop = document.scrollingElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.top = -scrollTop + 'px';
    },
    beforeClose: function() {
      // scrollTop lost after set position:fixed, restore it back.
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.top = '';
      document.scrollingElement.scrollTop = scrollTop;
    }
  };
})()


/**
 * 验证是否是微信环境
 */
export const checkWx = () => {
  let browser = {
    versions: (function() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        //移动终端浏览器版本信息
        trident: u.indexOf("Trident") > -1, //IE内核
        presto: u.indexOf("Presto") > -1, //opera内核
        webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
  if (browser.versions.mobile) {
    var ua = navigator.userAgent.toLowerCase();
    //在微信中打开
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  }
};


/**
 * 如果target(也就是obj1[key])存在，
 * 且是对象的话再去调用deepMerge，
 * 否则就是obj1[key]里面没这个对象，需要与obj2[key]合并
 */
export const deepMerge = (obj1, obj2) => {
  let key;
  for (key in obj2) {
    obj1[key] = obj1[key] && obj1[key].toString() === "[object Object]" ?
      deepMerge(obj1[key], obj2[key]) : obj1[key] = obj2[key];
  }
  return obj1;
}

/**
 * 数字转中文
 */
export const TransToChinese = num => {
  if (!num) return;
  var changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"]; //changeNum[0] = "零"
  var unit = ["", "十", "百", "千", "万"];
  num = parseInt(num);
  var getWan = temp => {
    var strArr = temp.toString().split("").reverse();
    var newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == 0 ?
          "" :
          i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ?
          "" :
          changeNum[strArr[i]] +
          (strArr[i] == 0 ? unit[0] : unit[i])) +
        newNum;
    }
    return newNum;
  };
  var overWan = Math.floor(num / 10000);
  var noWan = num % 10000;
  if (noWan.toString().length < 4) noWan = "0" + noWan;
  return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js